export default __webpack_public_path__ + "static/media/GR.886a6a40.svg";